import React from 'react';
import { useDispatch } from 'react-redux';

import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import history from '~/services/history';
import { toggleDrawer } from '~/store/modules/drawer/actions';

export default function MenuList({ styled, url, icon, title, hiddenMobile }) {
  const dispatch = useDispatch();

  /**
   * redirect user to url
   */
  async function handleClickButton() {
    await history.push('/redirect');
    await history.push(url);

    if (window.innerWidth <= 768) {
      dispatch(toggleDrawer());
    }
  }

  return (
    <ListItem
      button
      className={`${hiddenMobile && 'hiddenMobile'} ${styled}`}
      onClick={() => handleClickButton()}
    >
      {!isEmpty(icon) && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText primary={title} />
    </ListItem>
  );
}

MenuList.propTypes = {
  url: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  title: PropTypes.string.isRequired,
  styled: PropTypes.string,
};

MenuList.defaultProps = {
  icon: '',
  styled: '',
};
